import clsx from "clsx";
import BrandedLogo from "./branded-logo";

type Size = "sm" | "md" | "lg";

type Props = {
  size?: Size;
  className?: string;
};

const LOGO_WIDTH: Record<Size, string> = {
  sm: "w-[104px]",
  md: "w-[132px]",
  lg: "w-[220px]",
};

const BADGE: Record<Size, string> = {
  sm: "text-[9px] px-1.5 py-[3px] rounded-md",
  md: "text-[10px] px-2 py-[3px] rounded-md",
  lg: "text-[13px] px-2.5 py-1 rounded-lg",
};

/**
 * Rensure SME brand lockup: the RENSURE wordmark + an "SME" gradient badge.
 * Keeps the existing brand asset while reading as the rebranded product name.
 */
export default function BrandMark({ size = "md", className = "" }: Props) {
  return (
    <div className={clsx("flex items-center gap-2", className)}>
      <BrandedLogo
        className={clsx(LOGO_WIDTH[size], "shrink-0 opacity-95")}
        alt="Rensure SME"
      />
      <span
        className={clsx(
          "font-extrabold uppercase tracking-[0.14em] leading-none text-white shrink-0",
          "bg-gradient-to-br from-accent to-accent-bright shadow-sm shadow-indigo-500/30",
          BADGE[size]
        )}
      >
        SME
      </span>
    </div>
  );
}
